import classNames from 'classnames';
import * as React from 'react';
import { ColorStyleProps } from '../../../@types/theme';
import { convertColorToCSSVars } from '../../../utils';
import Icon, { IconProps } from '../Icon';

import styles from './DuotoneIcon.module.scss';

export interface Props extends Omit<IconProps, 'color'> {
  primaryColor?: ColorStyleProps;
  secondaryColor?: ColorStyleProps;
}

export const DuotoneIcon: React.FunctionComponent<Props> = ({
  className,
  style,
  icon,
  size,
  primaryColor = 'primary',
  secondaryColor = 'primaryLight',
  ...fontAwesomeProps
}) => {
  /**
   * We need to add this custom properties to the CSSProperties signature.
   * This is the recommended approach.
   *
   * For examples and more information, visit:
   * https://github.com/frenic/csstype#what-should-i-do-when-i-get-type-errors
   */
  const customStyle: React.CSSProperties = {
    ...style,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ['--fa-primary-color' as any]: `var(${convertColorToCSSVars(
      primaryColor,
    )})`,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ['--fa-secondary-color' as any]: `var(${convertColorToCSSVars(
      secondaryColor,
    )})`,
  };

  return (
    <Icon
      className={classNames(styles.icon, className)}
      style={customStyle}
      icon={icon}
      size={size}
      {...fontAwesomeProps}
    />
  );
};

export default DuotoneIcon;
